const filters = {
    date: function(value, format) {
        /*format值为y：显示到年-2018，d：显示到天-2018-6-2，m：显示到分钟-2018-6-2 12:32，s：显示到秒-2018-6-2 12:32:56 */
        if (value) {
            let date = new Date(value) // nuw 一个时间
            let getHours // 小时
            let getMinutes // 分
            let getSecond //秒
            if (date.getHours() < 10) { getHours = "0" + date.getHours() } else { getHours = date.getHours() }
            // 判断小时是否小于10的补全：加0
            if (date.getMinutes() < 10) { getMinutes = "0" + date.getMinutes() } else { getMinutes = date.getMinutes() }
            // 判断分是否小于10的补全：加0
            if (date.getSeconds() < 10) { getSecond = "0" + date.getSeconds() } else { getSecond = date.getSeconds() }
            // 判断秒是否小于10的补全：加0
            switch (format) {
                case 'y':
                    return date.getFullYear()
                    break;
                case 'd':
                    return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
                    break;
                case 'm':
                    return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() + " " + getHours + ":" + getMinutes
                    break;
                case 's':
                    return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() + " " + getHours + ":" + getMinutes + ":" + getSecond
                    break;
                default:
                    return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() + " " + getHours + ":" + getMinutes + ":" + getSecond
            }
        } else {
            return ''
        }
    },
    //保留指定n位小数,默认两位
    toDecimal: function(x, number) {
        var f = parseFloat(x);
        if (isNaN(f)) {
            return false;
        }
        var f = Math.round(x * 100) / 100;
        var s = f.toString();
        var rs = s.indexOf('.');
        var n = number ? number : 2;
        if (rs < 0) {
            rs = s.length;
            s += '.';
        }
        while (s.length <= rs + n) {
            s += '0';
        }
        return s;
    },
}
export default filters;


// WEBPACK FOOTER //
// ./src/filters/filters.js